/**
 * Fluid type scale + layout constants for kiosk screens.
 *
 * Kiosk runs on a Samsung tablet at ~800x1340 (portrait) and ~1340x800
 * (landscape). The viewport range is narrow enough that clamp() solves
 * almost every sizing need without media queries; reserve real
 * breakpoints for layout-direction changes (row -> column) only.
 *
 * Ranges:
 *   - displayTitle      28-48 px
 *   - verificationCode  48-80 px  (8-char monospace fits ~420 px column
 *                                  at the ceiling: 80 * 8 * 0.6 = 384 px)
 *   - countdown         28-44 px
 *   - bodyLg            17-18 px  (floor matches Mantine size="lg" so
 *                                  arm's-length legibility is preserved
 *                                  on the 800 px portrait kiosk)
 */
export const FLUID = {
  displayTitle: "clamp(28px, 5vw, 48px)",
  verificationCode: "clamp(48px, 12vw, 80px)",
  countdown: "clamp(28px, 5vw, 44px)",
  bodyLg: "clamp(17px, 1.8vw, 18px)",
} as const;

/**
 * Outer content cap. Wider than the previous 880 px so landscape
 * (1340 px) doesn't waste horizontal real estate, but narrow enough
 * that the layout doesn't sprawl on a developer's desktop viewport.
 */
export const KIOSK_CONTENT_MAX = 1100;
